(function(){
var vids=[].slice.call(document.querySelectorAll('.aur-lp video'));
var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
if('IntersectionObserver' in window){
var io=new IntersectionObserver(function(es){
es.forEach(function(e){
var v=e.target;
if(e.isIntersecting&&!reduce){ if(v.preload==='none') v.preload='auto'; var p=v.play(); if(p&&p.catch)p.catch(function(){}); }
else v.pause();
});
},{rootMargin:'200px 0px'});
vids.forEach(function(v){ io.observe(v); });
}
if(reduce) vids.forEach(function(v){ v.removeAttribute('autoplay'); v.pause(); });
var nums=[].slice.call(document.querySelectorAll('.aur-lp [data-count]'));
function fmt(v,d){return v.toFixed(d).replace('.',',');}
function run(el){
if(el._raf) cancelAnimationFrame(el._raf);
var to=parseFloat(el.dataset.count), d=parseInt(el.dataset.dec||'0',10), t0=null, dur=1800;
var box=el.closest('.cell,.protocol div'); if(box){ box.classList.remove('is-counting'); void box.offsetWidth; box.classList.add('is-counting'); }
function step(t){ if(!t0)t0=t; var k=Math.min((t-t0)/dur,1), e=1-Math.pow(1-k,3); el.textContent=fmt(to*e,d); if(k<1) el._raf=requestAnimationFrame(step); else el._raf=null; }
el.textContent=fmt(0,d); el._raf=requestAnimationFrame(step);
}
nums.forEach(function(n){
var box=n.closest('.cell,.protocol div')||n;
box.addEventListener('mouseenter',function(){ run(n); });
box.addEventListener('click',function(){ run(n); });
});
if('IntersectionObserver' in window){
var no=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting){ no.unobserve(e.target); run(e.target);} }); },{threshold:.35});
nums.forEach(function(n){ no.observe(n); });
}
var iv=document.getElementById('influence'), sb=document.getElementById('sound-btn');
sb.addEventListener('click',function(){
var on=iv.muted; iv.muted=!on;
if(on){ try{ iv.currentTime=0; }catch(e){} var p=iv.play(); if(p&&p.catch)p.catch(function(){}); }
sb.setAttribute('aria-pressed',on?'true':'false');
sb.setAttribute('aria-label',on?'Couper le son':'Activer le son');
});
var f=document.getElementById('waitlist-form'), msg=document.getElementById('form-msg'), input=document.getElementById('email');
if(/[?&]customer_posted=true/.test(location.search)){ f.hidden=true; msg.className='thanks'; msg.textContent='Merci. Vous serez parmi les premières informées.'; var ac=document.getElementById('acces'); if(ac) ac.scrollIntoView(); } f.addEventListener('submit',function(ev){

var ok=/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value.trim());
if(!ok){ ev.preventDefault(); msg.textContent="Entrez une adresse e-mail valide, par exemple nom@domaine.com."; input.focus(); return; }
f.hidden=true;
msg.className='thanks';
msg.textContent='Merci. Vous serez parmi les premières informées.';
});
})();
